import { TableBody, TableCell, TableRow } from '@/components/table';
import React from 'react';
import { Placeholder } from 'rsuite';
import { ITEMS_PER_PAGE } from '../constants';

export const ViolationsLoadingSkeleton: React.FC = () => {
  return (
    <TableBody>
      {Array.from({ length: ITEMS_PER_PAGE }).map((_, index) => (
        <TableRow key={index}>
          {Array.from({ length: 4 }).map((_, cellIndex) => (
            <TableCell key={cellIndex}>
              <Placeholder.Graph active width={100} height={30} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};

export default ViolationsLoadingSkeleton;
